
import React from 'react';
import './style.css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { useAppStore } from "../../context/state";

// components
import { Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
// import NavDropdown from 'react-bootstrap/NavDropdown';

import Slideshow from '../../components/Slideshow';
import HorizontalMenu from '../../components/HorizontalMenu';
import ItemComponent from '../../components/ItemComponent';
import HomeCarousel from '../../components/HomeCarousel';

import { 
  HiExternalLink
} from "react-icons/hi";

import {
  FaHome, FaUsers,
  FaBookOpen, FaNewspaper,
  FaBuilding
} from "react-icons/fa";

const Home = (props) =>{
  
  const { lang, loading } = props;
  const settings = useAppStore(state => state.settings) 
  const { 
    slides: collection, homemenu, news 
  } = settings || {slides:[], homemenu:[], news:{}}

  const booksList = useAppStore.getState().books
  const authorsList = useAppStore.getState().authors
  const random = useAppStore.getState().random || {firstName:"", lastName:"", photo: "/assets/app/author.png"}
  
  if(loading){
    return (
      <div className='home-warp' style={{ minHeight:'100vh' }}>
        <Row>
          <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 3, order: 1 }} style={{ 
              display:"flex", 
              alignItems:'center',
              flexDirection:'column'
            }}>
              <span>Te recomendamos {random.firstName ? 'este autor':' esta obra'}</span>
              <div style={{ width:'70%', height: '90%' }} className='skeleton'></div>
          </Col>
          <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} lg={{ span: 9, order: 2 }}>
            <div style={{ width:'100%', height: '300px'}} className='skeleton'></div>
          </Col>
        </Row>
        <Row>
          <div className="card" style={{border:'0px'}}>
            <div className="card-body">
              <div className="card-title">
                Algunas obras
              </div>
              <div style={{ 
                display:"flex", 
                alignItems:'center',
                flexDirection:'row'
              }}>
              {
                [1,2,3,4,5].map((key)=>{
                  return (<div key={key} style={{ width:'70%', height: '250px', margin:'10px' }} className='skeleton'></div>)
                })
              }
              </div>
            </div>
          </div>
        </Row>

        <Row>
          <div className="card" style={{border:'0px'}}>
            <div className="card-body">
              <div className="card-title">
                Algunas autores
              </div>
              <div style={{ 
                display:"flex", 
                alignItems:'center',
                flexDirection:'row'
              }}>
              {
                [1,2,3,4,5].map((key)=>{
                  return (<div key={key} style={{ width:'70%', height: '250px', margin:'10px' }} className='skeleton'></div>)
                })
              }
              </div>
            </div>
          </div>
        </Row>

      </div>
    )
  }

  return(

    <div className='home-warp'>
      <Row>
        <Col id="homeimage"  xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 3, order: 1 }} style={{ 
            display:"flex", 
            // justifyContent:'center', 
            alignItems:'center',
            flexDirection:'column'
          }}>
            <span>Te recomendamos {random.firstName ? 'este autor':' esta obra'}</span>
            <ItemComponent 
              random={random}
              className='main'
            />
        </Col>
        <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} lg={{ span: 9, order: 2 }}>
          <Slideshow
              id = "slideshow"
              input={collection}
              ratio={`16:4`}
              mode={`automatic`}
              timeout={`6000`}
              lang={lang}
            />
        </Col>
      </Row>

        {/* <Row>
          <Navbar 
              id='thirdnavbar'
              bg="primary" 
              expand="lg"  
              style={{ zIndex: 0 }} 
            >
            <Container fluid className="container-navbar">
            <Navbar.Toggle aria-controls="thirdnavbar"/>
              <Navbar.Collapse id="thirdnavbar"
                className='red-navbar'
              >
              <Nav>

              <Nav.Link as={Link} to="/editorial/" style={{color:'#FFF', margin:'auto'}}>
                <FaHome size={20} />
                {' '}INICIO
              </Nav.Link>

              <Nav.Link as={Link} to="/editorial/authors" style={{color:'#FFF', margin:'auto'}}>
                <FaUsers size={20} />
                {' '}AUTORES
              </Nav.Link>

              <Nav.Link as={Link} to="/editorial/books" style={{color:'#FFF', margin:'auto'}}>
                <FaBookOpen size={20} />
                {' '}CATÁLOGO
              </Nav.Link>
              
              <Nav.Link as={Link} to="/editorial/books/createdAt/last/sort" style={{color:'#FFF', margin:'auto'}}>
                <FaNewspaper size={20} />
                {' '}NOVEDADES
              </Nav.Link>

              <Nav.Link as={Link} to="https://humanidades.univalle.edu.co/" target='_blank' style={{color:'#FFF', margin:'auto'}}>
                <FaBuilding size={20} />
                {' '}FACULTAD
              </Nav.Link>

              </Nav>
            </Navbar.Collapse>
              
              <a href="https://www.univalle.edu.co/" target="_blank" rel="noreferrer" style={{color:'#FFF'}}>
                {' '}Universidad del valle <HiExternalLink size={20} />
              </a>

            </Container>
          </Navbar>
          
        </Row> */}
 {/* se elimina la navbar para dispositivos móviles */}


      <Row>
        <div className="card" style={{border:'0px'}}>
          <div className="card-body">
            <div className="card-title font-weight-bold">
              Algunas obras
            </div>
            <HomeCarousel
              dataList = {booksList}
            />
          </div>
        </div>
      </Row>

      <Row>
        <div className="card" style={{border:'0px'}}>
          <div className="card-body">
            <div className="card-title font-weight-bold">
              Algunos de nuestros autores
            </div>
            <HomeCarousel
              dataList = {authorsList}
            />
          </div>
        </div>
      </Row>
      <HorizontalMenu menu={homemenu} anew={news} lang={lang}/>
      
    </div>
  );
}

export default Home;
